(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-news"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const formWrapper = document.querySelector('.c_news-form');
  if (formWrapper) {
    formWrapper.addEventListener('submit', function(event) {
      if (event.target.tagName === 'FORM') {
        const form = event.target;
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
          const email = emailInput.value;
          const formData = { email: email };
        
          // Publish the event to Shopify Analytics.
          Shopify.analytics.publish('contact_form_submit', { form_data: formData });
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
